import { useCallback, useEffect, useRef } from 'react';
import { getLocale, shallowEqual, useDispatch, useSelector } from 'umi';
import { LANGUAGE_EN } from '../../_config/constant';
import { localeKeyMap } from '../../utils/utils';
import { useNewSelectorParams } from '../../utils/useNewSelectorParams';
import { FilterItemType } from '../../types/dashboard';

/** @param extraFilterList 追加到 new_selector 请求（如 inputList 中带 allowMissingBackendKey 的 key），见 useNewSelectorParams */
export const useFilterData = (path:string,timeType = 'daily', pageDefaultSelector?: FilterItemType[], isUseFrontFilterConfig?:boolean, extraFilterList?:string[]) => {
  const dispatch = useDispatch();
  const gameCode = useSelector(
    (state: any) => state.dashboard?.currentGame?.game_code,
    shallowEqual,
  );
  // 用 ref 存储快照，useEffect 仅 mount 时执行一次，切游戏时页面整体重新挂载
  const gameCodeRef = useRef(gameCode);
  gameCodeRef.current = gameCode;
  const  { loading, getSelectorList} = useNewSelectorParams({
    realPath: path,
    pageDefaultSelector: pageDefaultSelector || [],
    isUseFrontFilterConfig: isUseFrontFilterConfig || false,
    extraFilterList,
  });
  const selectorRef = useRef<any>({});

  useEffect(() => {
    getSelectorList().then((data)=>{
      const metricsList = data?.metrics_list?.[timeType] || [];
      selectorRef.current = { ...(data || {}), metrics_list: metricsList, gameCode: gameCodeRef.current };
      dispatch({
        type: 'dashboardSetting/save',
        payload: {
          selector: selectorRef.current,
        },
      });
    }).catch((e)=>{
      console.log(e);
    });
  }, []);

  return {
    loading,
    selector: selectorRef.current
  };
};

// 筛选器数据中英文翻译
export const usePcDateSelectorMap = (selectorVal: any) => {
  const locale = getLocale();
  const { selectorMap, ...selector } = selectorVal || {};

  // 筛选器中英文翻译
  const usePcDateSelectorText = useCallback((regionDataType: string, key: string) => {
    const isEn = locale === LANGUAGE_EN;
    if (localeKeyMap[key?.toLowerCase()]) {
      return isEn ? key : localeKeyMap[key.toLowerCase()];
    }
    if (!selector) return key;
    const localeMap = selectorMap?.nameEnMap;
    if (!localeMap || isEn) {
      return key;
    }
    return localeMap?.[regionDataType]?.[key] || key;
  }, [selector, locale]);

  const getCodeText = useCallback((type: string | number, key: string) => {
    const isEn = locale === LANGUAGE_EN;
    if (localeKeyMap[key?.toLowerCase()]) {
      return isEn ? key : localeKeyMap[key.toLowerCase()];
    }
    if (!selector) return key;
    const localeMap = selectorMap?.nameCnMap;
    if (!localeMap) {
      return key;
    }

    if (isEn) {
      return localeMap?.[type]?.[key]?.en || key;
    } 
    return localeMap?.[type]?.[key]?.cn || localeMap?.[type]?.[key]?.en || key;
    
  }, [selector, locale]);
  
  return {
    usePcDateSelectorText,
    getCodeText,
    locale,
  };
};
